import { render } from "./Debts.vue?vue&type=template&id=4cc7de13&scoped=true"
import script from "./Debts.vue?vue&type=script&lang=js"
export * from "./Debts.vue?vue&type=script&lang=js"

import "./Debts.vue?vue&type=style&index=0&id=4cc7de13&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc7de13"]])

export default __exports__